function pluralForm (n, w1, w2 = '', w3 = '') {
  let ret = ''
  if (n < 0) {
    n *= -1
  }
  if (n >= 11 && n <= 19) {
    ret = (w3 !== '' ? w3 : w1)
  } else {
    n %= 10
    if (n === 1) {
      ret = w1
    } else if (n === 0 || n >= 5) {
      ret = (w3 !== '' ? w3 : w1)
    } else {
      ret = (w2 !== '' ? w2 : w1)
    }
  }
  return ret
}

function getDateYmd (dt) {
  return dt.getFullYear() + '-' + ('' + (dt.getMonth() + 1)).padStart(2, '0') + '-' + ('' + dt.getDate()).padStart(2, '0')
}

function getDateDmy (dt) {
  return ('' + dt.getDate()).padStart(2, '0') + '-' + ('' + (dt.getMonth() + 1)).padStart(2, '0') + '-' + dt.getFullYear()
}

export default {
  pluralForm,
  getDateYmd,
  getDateDmy
}
